import React from "react";
import { Chip, Stack, Typography, Grid, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "@quest_editor/components/SectionHeader";

type Row = {
  label?: string;
  required?: boolean;
  note?: string;
  extra?: React.ReactNode;
  children: React.ReactNode;
};

const InfoSection = ({
  title,
  rightContent,
  rows,
}: {
  title?: string;
  rightContent?: React.ReactNode;
  rows: Row[];
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Paper variant={title ? "outlined" : "elevation"} elevation={0}>
      {title && (
        <SectionHeader title={title} rightContent={rightContent} />
      )}
      {rows.map((row, i) => (
        <Grid
          container
          sx={{ borderBottom: 1, color: "divider" }}
          alignItems="center"
          key={i}
        >
          <Grid xs={3} p={2}>
            <Stack direction="column" spacing={2}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                spacing={1}
              >
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  color="text.primary"
                  sx={{ whiteSpace: "pre-line" }}
                >
                  {row.label}
                </Typography>
                {row.required && (
                  <Chip
                    label={t("form_row.required")}
                    size="small"
                    color="error"
                  />
                )}
              </Stack>

              {row.note && (
                <Typography variant="body2" color="error">
                  {row.note}
                </Typography>
              )}

              {row.extra}
            </Stack>
          </Grid>

          <Grid xs={9} p={2} alignSelf="stretch">
            {row.children}
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};
export default InfoSection;
